/* eslint-disable no-else-return */
/* eslint-disable no-param-reassign */
/* eslint-disable no-continue */
import * as THREE from 'three';
import * as marietta from '../..';
import { SVGSprite } from '../flash/display';
import { FloorLayer, FloorShitaeLayer } from '.';
import { Stage } from '../model';
import { BoundInfoCollection } from '../collection';
import { CONTROL_ACTIONMODE, ITEM_MODE_NO } from '../Constants';
import { Point } from '../../core';

export default class LayerGroup {
    floor1: marietta.webcad.layer.FloorLayer;

    floor2: marietta.webcad.layer.FloorLayer;

    floor3: marietta.webcad.layer.FloorLayer;

    floorShitae1: marietta.webcad.layer.FloorShitaeLayer;

    floorShitae2: marietta.webcad.layer.FloorShitaeLayer;

    floorShitae3: marietta.webcad.layer.FloorShitaeLayer;

    grid: marietta.webcad.layer.GridLayer;

    maskForFitting: marietta.webcad.layer.FloorLayer;

    public spt: SVGSprite;

    public layerMove: boolean = false;

    public allPositionConversion:Point = new Point(0, 0);

    /**
     * Constructor
     */
    constructor() {
      const layerGroup = document.getElementById('layerGroup');

      layerGroup.classList.add('svgSprite');
      this.spt = new SVGSprite(layerGroup);

      // グリッドレイヤー
      this.grid = new marietta.webcad.layer.GridLayer(this.spt);

      // 初期化
      this.initMe();
    }

    /*
     * コンストラクタで実行するとwebcad2dViewInnerのオフセット位置が正しく
     * 取れないため、Masterの初期化が終わってから実行すること
     */
    public initialize(): void {
      const scope: LayerGroup = this;

      /* this.spt.onEnterFrame = function():void
          {
              const pos:JQueryCoordinates = scope.spt.element.offset();
              Debugger.text(0, pos.left);
              Debugger.text(1, pos.top);
          }; */

      // WEBCAD-1482対応 k.kubonaka
      let addressBarOffset: number = 0;

      const ua = marietta.webcad.WebCADGlobal.userAgentManager;
      if (ua.isMobile/* || ua.isTablet */) {
        // アドレスバーの高さを考慮
        addressBarOffset = window.pageYOffset;
      }

      const con: HTMLElement = document.getElementById('webcad2dViewInner');
      con.addEventListener('scroll', (e): void => {
        if (ua.isMobile) {
          // アドレスバーの高さを考慮
          addressBarOffset = window.pageYOffset;
        }

        e.preventDefault();
        const pos: DOMRect = scope.spt.element.getBoundingClientRect();
        Stage.offsetX = pos.left;
        Stage.offsetY = pos.top - addressBarOffset;
      });

      const pos: DOMRect = scope.spt.element.getBoundingClientRect();
      Stage.offsetX = pos.left;
      Stage.offsetY = pos.top - addressBarOffset;
      // アクション
      if (marietta.webcad.WebCADGlobal.userAgentManager.isMobile || marietta.webcad.WebCADGlobal.userAgentManager.isTablet) {
        con.addEventListener('touchstart', this.onMouseDown, { passive: false });
        // 2本指ピンチズーム（Safari GestureEvent）
        con.addEventListener('gesturestart', marietta.webcad.WebCADGlobal.scrollerManager.startHandler);
      } else {
        con.addEventListener('mousedown', this.onMouseDown);
      }
    }

    /**
     * レイヤ―の初期化
     */
    initMe() {
      // var layerGroup = document.getElementById('layerGroup');

      if (this.floor1 !== undefined) {
        this.floor1.remove();
        this.floor2.remove();
        this.floor3.remove();
        this.floorShitae1.remove();
        this.floorShitae2.remove();
        this.floorShitae3.remove();
      }

      // 階レイヤーの作成
      this.floor1 = new marietta.webcad.layer.FloorLayer(1, this.spt);
      this.floorShitae1 = new marietta.webcad.layer.FloorShitaeLayer(1, this.spt);
      this.floor2 = new marietta.webcad.layer.FloorLayer(2, this.spt);
      this.floorShitae2 = new marietta.webcad.layer.FloorShitaeLayer(2, this.spt);
      this.floor3 = new marietta.webcad.layer.FloorLayer(3, this.spt);
      this.floorShitae3 = new marietta.webcad.layer.FloorShitaeLayer(3, this.spt);

      // 1階以外を隠す
      for (let i: number = 1; i <= marietta.webcad.WebCADGlobal.MAX_FLOORS; i += 1) {
        const tarLayer = this.getFloorLayer(i) as FloorLayer;
        if (i <= 1) {
          tarLayer.show();
        } else {
          tarLayer.hide();
        }
      }
    }

    /**
     * レイヤ―の取得
     */
    getTargetLayer(id: string, no: number, shitae: boolean = false) {
      const floorLayer = shitae ? this[`floorShitae${no}`] as marietta.webcad.layer.FloorShitaeLayer : this[`floor${no}`] as marietta.webcad.layer.FloorLayer;
      return floorLayer.getTargetLayer(id);
    }

    /**
    * レイヤ―の取得
    */
    getFloorLayer(no: number, shitae: boolean = false) {
      const floorLayer = shitae ? this[`floorShitae${no}`] as marietta.webcad.layer.FloorShitaeLayer : this[`floor${no}`] as marietta.webcad.layer.FloorLayer;
      return floorLayer;
    }

    /**
     * アイテムレイヤーの取得
     */
    getTypeLayerInFloorLayer(floorNo: number, modeNo: number) {
      const getFloorLayer: marietta.webcad.layer.FloorLayer = this.getFloorLayer(floorNo);
      if (getFloorLayer == null) return null;

      return getFloorLayer.getLayerByKey('modeNo', modeNo);
    }

    /**
     * レイヤーの表示切替
     */
    showLayer(modeNo: number, floorNo: number) {
      let tarLayer: FloorLayer;
      let tarShitaeLayer: FloorShitaeLayer;

      // カレントアイテムが作成中であれば削除
      marietta.webcad.WebCADGlobal.itemManager.deleteUnplacedItems();

      // 初期化
      for (let i: number = 1; i <= marietta.webcad.WebCADGlobal.MAX_FLOORS; i += 1) {
        tarLayer = this.getFloorLayer(i) as FloorLayer;
        if (i <= floorNo) {
          tarLayer.show(Boolean(modeNo === ITEM_MODE_NO.MODE_ROOF_NO));
        } else {
          tarLayer.hide();
        }
      }

      // 寸法線と下絵の表示切替
      for (let i: number = 1; i <= marietta.webcad.WebCADGlobal.MAX_FLOORS; i += 1) {
        tarLayer = this.getFloorLayer(i) as FloorLayer;
        tarShitaeLayer = this.getFloorLayer(i, true) as FloorShitaeLayer;
        if (i === floorNo) {
          (tarLayer.layer_measure as marietta.webcad.layer.MeasureLayer).show();
          (tarShitaeLayer.layer_shitae as marietta.webcad.layer.ShitaeLayer).show();
        } else {
          (tarLayer.layer_measure as marietta.webcad.layer.MeasureLayer).hide();
          (tarShitaeLayer.layer_shitae as marietta.webcad.layer.ShitaeLayer).hide();
        }
      }

      // グリッドを描くレイヤーの上に移動
      const tempGrid = this.grid.spt.element;
      tarLayer = this.getFloorLayer(floorNo) as FloorLayer;
      tarLayer.before(tempGrid);
      this.grid.refreshLines();
    }

    /**
     * ○階だて？
     * @return number
     * */
    getHighestFloor(): number {
      let tarLayer: marietta.webcad.layer.ItemLayer;

      // ３階
      tarLayer = this.getTargetLayer('rom', 3);
      if (tarLayer.isItemInMe()) return 3;

      // ２階
      tarLayer = this.getTargetLayer('rom', 2);
      if (tarLayer.isItemInMe()) return 2;

      // １階
      return 1;
    }

    /**
     * 領域情報の取得
     * @param 寸法線を含める
     * */
    getBoundInfo(includeMeasure: boolean = false, includeExterior: boolean = true, deferredObj = null): BoundInfoCollection {
      let minPoint: marietta.core.Point;
      let maxPoint: marietta.core.Point;
      let layerMinMax;
      let allWidth: number;
      let allHeight: number;
      let center: marietta.core.Point;
      let tarLayer: marietta.webcad.layer.FloorLayer;
      let bound: DOMRect;

      // 全ての階を非表示にする
      // MINとMAXを調べる
      for (let i: number = 1; i <= marietta.webcad.WebCADGlobal.MAX_FLOORS; i += 1) {
        tarLayer = this.getFloorLayer(i);
        bound = tarLayer.spt.getBoundingClientRect();
        if (bound.width < 1) continue;

        layerMinMax = tarLayer.getMinMaxPointVisible(includeMeasure, includeExterior);
        if (layerMinMax == null) continue;

        if (minPoint == null) minPoint = new marietta.core.Point(layerMinMax.minX, layerMinMax.minY);
        if (maxPoint == null) maxPoint = new marietta.core.Point(layerMinMax.maxX, layerMinMax.maxY);
        if (Number.isNaN(minPoint.x) || layerMinMax.minX < minPoint.x) { minPoint.x = layerMinMax.minX; }
        if (Number.isNaN(minPoint.y) || layerMinMax.minY < minPoint.y) { minPoint.y = layerMinMax.minY; }
        if (Number.isNaN(maxPoint.x) || layerMinMax.maxX > maxPoint.x) { maxPoint.x = layerMinMax.maxX; }
        if (Number.isNaN(maxPoint.y) || layerMinMax.maxY > maxPoint.y) { maxPoint.y = layerMinMax.maxY; }
      }
      let retObject: BoundInfoCollection = new BoundInfoCollection();
      if (minPoint != null && maxPoint != null) {
        minPoint.x -= marietta.webcad.WebCADGlobal.OUTERFRAME_LEFT_FRAME_WIDTH;
        minPoint.y -= marietta.webcad.WebCADGlobal.OUTERFRAME_HEADER_HEIGHT;
        maxPoint.x -= marietta.webcad.WebCADGlobal.OUTERFRAME_LEFT_FRAME_WIDTH;
        maxPoint.y -= marietta.webcad.WebCADGlobal.OUTERFRAME_HEADER_HEIGHT;
        allWidth = Math.max(minPoint.x, maxPoint.x) - Math.min(minPoint.x, maxPoint.x);
        allHeight = Math.max(minPoint.y, maxPoint.y) - Math.min(minPoint.y, maxPoint.y);
        center = new marietta.core.Point(minPoint.x + allWidth / 2, minPoint.y + allHeight / 2);
        retObject = {
          minPoint, maxPoint, width: allWidth, height: allHeight, center,
        };
      }

      if (deferredObj) deferredObj.resolve();
      return retObject;
    }

    /**
     * 領域情報の取得（ポーチを除く部屋、階段）
     * */
    getRoomBoundInfo(resolve = null) {
      let minPoint: marietta.core.Point;
      let maxPoint: marietta.core.Point;
      let layerMinMax;
      let allWidth: number;
      let allHeight: number;
      let center: marietta.core.Point;
      let tarLayer: marietta.webcad.layer.FloorLayer;
      let bound;

      // 全ての階を非表示にする
      // MINとMAXを調べる
      for (let i: number = 1; i <= marietta.webcad.WebCADGlobal.MAX_FLOORS; i += 1) {
        tarLayer = this.getFloorLayer(i);
        bound = tarLayer.spt.getBoundingClientRect();
        if (bound.width < 1) continue;

        layerMinMax = tarLayer.getRoomMinMaxPointVisible();
        if (layerMinMax == null) continue;
        if (minPoint == null) minPoint = new marietta.core.Point(layerMinMax.minX, layerMinMax.minY);
        if (maxPoint == null) maxPoint = new marietta.core.Point(layerMinMax.maxX, layerMinMax.maxY);
        if (Number.isNaN(minPoint.x) || layerMinMax.minX < minPoint.x) { minPoint.x = layerMinMax.minX; }
        if (Number.isNaN(minPoint.y) || layerMinMax.minY < minPoint.y) { minPoint.y = layerMinMax.minY; }
        if (Number.isNaN(maxPoint.x) || layerMinMax.maxX > maxPoint.x) { maxPoint.x = layerMinMax.maxX; }
        if (Number.isNaN(maxPoint.y) || layerMinMax.maxY > maxPoint.y) { maxPoint.y = layerMinMax.maxY; }
      }
      let retObject: BoundInfoCollection = new BoundInfoCollection();
      retObject = {
        minPoint, maxPoint, width: 0, height: 0, center: null,
      };
      if (minPoint != null && maxPoint != null) {
        minPoint.x -= marietta.webcad.WebCADGlobal.OUTERFRAME_LEFT_FRAME_WIDTH;
        minPoint.y -= marietta.webcad.WebCADGlobal.OUTERFRAME_HEADER_HEIGHT;
        maxPoint.x -= marietta.webcad.WebCADGlobal.OUTERFRAME_LEFT_FRAME_WIDTH;
        maxPoint.y -= marietta.webcad.WebCADGlobal.OUTERFRAME_HEADER_HEIGHT;
        allWidth = Math.max(minPoint.x, maxPoint.x) - Math.min(minPoint.x, maxPoint.x);
        allHeight = Math.max(minPoint.y, maxPoint.y) - Math.min(minPoint.y, maxPoint.y);
        center = new marietta.core.Point(minPoint.x + allWidth / 2, minPoint.y + allHeight / 2);
        retObject = {
          minPoint, maxPoint, width: allWidth, height: allHeight, center,
        };
      }

      if (resolve) resolve();
      return retObject;
    }

    /**
     * 階レイヤーの移動
     * */
    moveFloorLayers(numXway: number, numYway: number) {
      let tarLayer: marietta.webcad.layer.FloorLayer;
      let i: number;

      // 移動
      if (!Number.isNaN(numXway) === true && Number.isFinite(numXway) === true) {
        if (numXway > 0) { numXway = 0; }
        this.grid.x = numXway;
        for (i = 1; i <= marietta.webcad.WebCADGlobal.MAX_FLOORS; i += 1) {
          tarLayer = this.getFloorLayer(i);
          tarLayer.x = numXway;
        }
      }
      if (!Number.isNaN(numYway) === true && Number.isFinite(numYway) === true) {
        if (numYway < 0) { numYway = 0; }
        this.grid.y = numYway;
        for (i = 1; i <= marietta.webcad.WebCADGlobal.MAX_FLOORS; i += 1) {
          tarLayer = this.getFloorLayer(i);
          tarLayer.y = numYway;
        }
      }
    }

    /**
    * アイテム一覧の取得
    * @return Array アイテム一覧
    */
    getAllItems() {
      let retList = [];
      let tarLayer: marietta.webcad.layer.FloorLayer;
      for (let i: number = 1; i <= marietta.webcad.WebCADGlobal.MAX_FLOORS; i += 1) {
        tarLayer = this.getFloorLayer(i);
        retList = retList.concat(tarLayer.getAllItems());
      }
      return retList;
    }

    /**
    * アイテム一覧の取得
    * @return アイテム一覧
    */
    getItemWithGuid(guid:string) {
      let item = null;
      let tarLayer: marietta.webcad.layer.FloorLayer;
      for (let i: number = 1; i <= marietta.webcad.WebCADGlobal.MAX_FLOORS; i += 1) {
        tarLayer = this.getFloorLayer(i);
        item = tarLayer.getItemWithGuid(guid);
        if (item) break;
      }
      return item;
    }

    /**
    * 下絵一覧の取得
    * @return Array 下絵一覧
    */
    getAllShitae() {
      let retList = [];
      let tarLayer: marietta.webcad.layer.FloorShitaeLayer;
      for (let i: number = 1; i <= marietta.webcad.WebCADGlobal.MAX_FLOORS; i += 1) {
        tarLayer = this.getFloorLayer(i, true) as marietta.webcad.layer.FloorShitaeLayer;
        retList = retList.concat(tarLayer.getAllItems());
      }
      return retList;
    }

    /**
     * 全てのアイテムを中央に移動（座標変換）
     * */
    convertAllToCenter(): void {
      const boundInfo = this.getBoundInfo();
      const paperCenterX: number = marietta.webcad.WebCADGlobal.LAYER_SIZE_W / 2;
      const paperCenterY: number = marietta.webcad.WebCADGlobal.LAYER_SIZE_H / 2;
      const moveX: number = Math.round((paperCenterX - boundInfo.center.x) / marietta.webcad.WebCADGlobal.PIX_IN_GRID) * marietta.webcad.WebCADGlobal.PIX_IN_GRID;
      const moveY: number = Math.round((paperCenterY - boundInfo.center.y) / marietta.webcad.WebCADGlobal.PIX_IN_GRID) * marietta.webcad.WebCADGlobal.PIX_IN_GRID;
      let tarLayer: FloorLayer;
      let tarLayerShitae: FloorShitaeLayer;

      for (let i: number = 1; i <= 3; i += 1) {
        tarLayer = this.getFloorLayer(i) as FloorLayer;
        tarLayer.moveAllItems(moveX, moveY);

        tarLayerShitae = this.getFloorLayer(i, true) as FloorShitaeLayer;
        tarLayerShitae.moveAllItems(moveX, moveY);
      }

      // 屋根デザインの取得
      marietta.webcad.WebCADGlobal.itemManager.getAllRoofs();
    }

    /**
     * レイヤーグループが押された
     */
    onMouseDown = (e) => {
      // 2本指ジェスチャ（ピンチ・パン）の2本目のタッチ開始では、選択操作を開始しない。
      // ここで弾かないと、範囲選択の開始点が2本目の指の位置で上書きされてしまう。
      if (e && e.touches && e.touches.length > 1) {
        return;
      }
      marietta.webcad.WebCADGlobal.overlapItemList.hideList();
      if (marietta.webcad.WebCADGlobal.webcad2Dmanager.isViewMode()) {
        return;
      }
      if (e && e.target) {
        if (((e.target) as HTMLElement).classList.contains('pinLink')) {
          return;
        } else if (((e.target) as HTMLElement).parentElement.classList.contains('pinLink')) {
          return;
        }
      }

      //ピン情報編集中
      if (e && e.target) {
        let target:HTMLElement = (e.target as HTMLElement);
        while (target) {

          if(target.getAttribute('id') && -1 < target.getAttribute('id').indexOf("_pinText") ){
            return;
          }
          target = target.parentElement;
        }
      }

      // if(marietta.webcad.WebCADGlobal.webcad2Dmanager.keyIsDown(32)){ //SPACE
      //     marietta.webcad.WebCADGlobal.scrollerManager.startDragMainLayer(e);
      // }else{
      //     //範囲指定
      //     marietta.webcad.WebCADGlobal.itemManager.startDragGroupSelect();
      // }
      // ウォールガイドのテキストボックスを削除
      if ((e.target as HTMLElement).id !== 'guideText') {
        if (document.querySelector('.wallGuideTextbox')) {
          document.querySelectorAll('.wallGuideTextbox').forEach((element) => {
            element.remove();
          });
        }
        if (document.querySelector('.wallGuideText')) {
          document.querySelectorAll('.wallGuideText').forEach((element:SVGElement) => {
            // eslint-disable-next-line no-param-reassign
            element.style.display = 'block';
          });
        }
      }

      switch (marietta.webcad.WebCADGlobal.webcad2Dmanager.currentActionMode) {
        case CONTROL_ACTIONMODE.ACTIONMODE_CONTROL_STAGE:
          marietta.webcad.WebCADGlobal.scrollerManager.startDragMainLayer(e);
          break;
        case CONTROL_ACTIONMODE.ACTIONMODE_SELECT_ITEM:
          if (marietta.webcad.WebCADGlobal.itemManager.itemController instanceof marietta.webcad.control.ItemControllerLidarAddPin) return;
          if (marietta.webcad.WebCADGlobal.userAgentManager.isPC && !(marietta.webcad.WebCADGlobal.itemManager.currentItemGroup && marietta.webcad.WebCADGlobal.itemManager.currentItemGroup.isFollowingMouse)) {
            marietta.webcad.WebCADGlobal.itemManager.startDragGroupSelect();
          } else if (!marietta.webcad.WebCADGlobal.userAgentManager.isPC) {
            if (marietta.webcad.WebCADGlobal.webcad2Dmanager.isMultipleSelect) {
              e.preventDefault();
              e.stopPropagation();
              Stage.refreshStageMouse(<any>e);
              // 複数選択モード中はアイテム以外をタップしただけで選択が解除されないよう、既存の選択を保持する
              marietta.webcad.WebCADGlobal.itemManager.startDragGroupSelect(true);
            } else {
              // カレントをなくす
              marietta.webcad.WebCADGlobal.itemManager.unselectAllCurrents();
            }
          }
          break;
        case CONTROL_ACTIONMODE.ACTIONMODE_SELECT_SITE:
          break;
        case CONTROL_ACTIONMODE.ACTIONMODE_INPUT_POINT_SITE:
          break;
        case CONTROL_ACTIONMODE.ACTIONMODE_INPUT_POINT_ROOM:
          // marietta.webcad.WebCADGlobal.itemManager.startRoomKakomiInput();
          break;
        case CONTROL_ACTIONMODE.ACTIONMODE_INPUT_DRAG_ROOM:
          break;
        case CONTROL_ACTIONMODE.ACTIONMODE_INPUT_DRAG_FITTING:
          // marietta.webcad.WebCADGlobal.itemManager.startFittingDragInput();
          break;
        case CONTROL_ACTIONMODE.ACTIONMODE_INPUT_WALL:
          // marietta.webcad.WebCADGlobal.itemManager.startRoomKakomiInput();
          break;
        default: break;
      }
    }

    /**
     * 建具アイテムの全初期化
     * @param targetAllFloor:boolean 表示中のフロアだけか、全フロアを対象にするか
     */
    initFittingLayers(targetAllFloor: boolean = true): void {
      let tarLayer: marietta.webcad.layer.FloorLayer;
      for (let i: number = 1; i <= 3; i += 1) {
        if (!targetAllFloor && (i !== marietta.webcad.WebCADGlobal.webcad2Dmanager.currentFloor)) continue;
        tarLayer = this.getFloorLayer(i) as FloorLayer;
        tarLayer.initFittingLayer();
      }
    }

    /**
     * 住宅設備アイテムの全初期化
     * @param targetAllFloor:boolean 表示中のフロアだけか、全フロアを対象にするか
     */
    initEquipmentLayers(targetAllFloor: boolean = true): void {
      let tarLayer: marietta.webcad.layer.FloorLayer;
      for (let i: number = 1; i <= 3; i += 1) {
        if (!targetAllFloor && (i !== marietta.webcad.WebCADGlobal.webcad2Dmanager.currentFloor)) continue;
        tarLayer = this.getFloorLayer(i) as FloorLayer;
        tarLayer.initEquipmentLayer();
      }
    }

    /**
     * 廊下アイテムの全初期化
     * （ポーチは初期化しない）
     * @param targetAllFloor:boolean 表示中のフロアだけか、全フロアを対象にするか
     */
    initRoomdownLayers(targetAllFloor: boolean = true): void {
      let tarLayer: marietta.webcad.layer.FloorLayer;
      for (let i: number = 1; i <= 3; i += 1) {
        if (!targetAllFloor && (i !== marietta.webcad.WebCADGlobal.webcad2Dmanager.currentFloor)) continue;
        tarLayer = this.getFloorLayer(i) as FloorLayer;
        tarLayer.initRoomdownLayer();
      }
    }

    /**
     * レイヤーのマウス操作制御
     * ※コントローラーには影響ない
     */
    enableItemMouseActions(value: boolean): void {
      let tarLayer: marietta.webcad.layer.FloorLayer;
      for (let i: number = 1; i <= 3; i += 1) {
        tarLayer = this.getFloorLayer(i) as FloorLayer;
        tarLayer.enableItemMouseActions(value);
      }
    }

    // 有効・無効設定
    private _siteEnabled: boolean = false;

    get siteEnabled() { return this._siteEnabled; }

    set siteEnabled(value: boolean) {
      this._siteEnabled = value;

      // TODO: 後で実装
      // this.mouseEnabled = this._enabled;
      // this.mouseChildren = this._enabled;
    }

    // 有効・無効設定
    private _itemEnabled: boolean = false;

    get itemEnabled() { return this._itemEnabled; }

    set itemEnabled(value: boolean) {
      this._itemEnabled = value;

      // TODO: 後で実装
      // this.mouseEnabled = this._enabled;
      // this.mouseChildren = this._enabled;
    }

  /**
       * Shitae and Floorレイヤーを移動します
       * @param modeNo type: number
       * @param floorNo type:number
      */
  /* moveShitaeFloorLayer(floorNo: number) {
          var tarLayer: FloorLayer;
          var tarShitaeLayer: FloorShitaeLayer;
          var tempGrid = this.grid.spt.element;
          tarLayer = this.getFloorLayer(floorNo) as FloorLayer;
          tarShitaeLayer = this.getFloorLayer(floorNo, true) as FloorShitaeLayer;
          if(this.layerMove) {
              //グリッドを描くレイヤーの上に移動
              //tarLayer.after(tarShitaeLayer.spt.element);
              //tempGrid.before(tarLayer.spt.element);
          } else {
              //グリッドを描くレイヤーの上に移動
              //tempGrid.after(tarLayer.spt.element);
              //tempGrid.before(tarShitaeLayer.spt.element);
          }
      } */

    /**
     * 印刷用
     * 左上に合わせる
     */
    convertAllToLeftTop(floor: number = null): {x: number, y: number} {
      const boundInfo = this.getAllSVGBoundInfo(floor);
      const marginLeft = 50;
      const marginTop = 30;
      const center = boundInfo.getCenter(new THREE.Vector2());
      const size = boundInfo.getSize(new THREE.Vector2());
      const moveX: number = Math.round((size.width / 2 - center.x)) + marginLeft;
      const moveY: number = Math.round((size.height / 2 - center.y)) + marginTop;
      if (floor) {
        const tarLayer = this.getFloorLayer(floor) as FloorLayer;
        tarLayer.moveAllItems(moveX, moveY);
        tarLayer.layer_upstair.moveAll(moveX, moveY);
        // const tarLayerShitae = this.getFloorLayer(floor, true) as FloorShitaeLayer;
        // tarLayerShitae.moveAllItems(moveX, moveY);
      } else {
        for (let i: number = 1; i <= 3; i += 1) {
          const tarLayer = this.getFloorLayer(i) as FloorLayer;
          tarLayer.moveAllItems(moveX, moveY);
          tarLayer.layer_upstair.moveAll(moveX, moveY);
          // const tarLayerShitae = this.getFloorLayer(i, true) as FloorShitaeLayer;
          // tarLayerShitae.moveAllItems(moveX, moveY);
        }
      }
      // 全体の移動距離を保持しておき、後生成アイテムのために保持しておく
      this.allPositionConversion.x += moveX;
      this.allPositionConversion.y += moveY;
      return { x: moveX, y: moveY };
    }

    /**
     * 領域情報の取得
     * @param 寸法線を含める
     * */
    public getAllSVGBoundInfo(floor: number = null): THREE.Box2 {
      let minPoint:THREE.Vector2 = null;
      let maxPoint:THREE.Vector2 = null;
      const calculateBoud = (floor: number) => {
        const tarLayer = this.getFloorLayer(floor);
        // const shitaeLayer = this.getFloorLayer(floor, true) as FloorShitaeLayer;
        const bound = tarLayer.spt.getBoundingClientRect();
        // const shitaeBound = shitaeLayer.spt.getBoundingClientRect();
        if (bound.width < 1) return;

        const layerMinMax = tarLayer.getSVGMinMaxPointVisible();
        // const shitaeLayerMinMax = shitaeLayer.getSVGMinMaxPointVisible();
        // if (layerMinMax == null && shitaeLayerMinMax == null) return;
        if (layerMinMax == null) return;
        if (layerMinMax) {
          if (minPoint == null) minPoint = layerMinMax.min;
          if (maxPoint == null) maxPoint = layerMinMax.max;
          if (layerMinMax.min.x < minPoint.x) { minPoint.x = layerMinMax.min.x; }
          if (layerMinMax.min.y < minPoint.y) { minPoint.y = layerMinMax.min.y; }
          if (layerMinMax.max.x > maxPoint.x) { maxPoint.x = layerMinMax.max.x; }
          if (layerMinMax.max.y > maxPoint.y) { maxPoint.y = layerMinMax.max.y; }
        }
        // if (shitaeLayerMinMax) {
        //   if (minPoint == null) minPoint = shitaeLayerMinMax.min;
        //   if (maxPoint == null) maxPoint = shitaeLayerMinMax.max;
        //   if (shitaeLayerMinMax.min.x < minPoint.x) { minPoint.x = shitaeLayerMinMax.min.x; }
        //   if (shitaeLayerMinMax.min.y < minPoint.y) { minPoint.y = shitaeLayerMinMax.min.y; }
        //   if (shitaeLayerMinMax.max.x > maxPoint.x) { maxPoint.x = shitaeLayerMinMax.max.x; }
        //   if (shitaeLayerMinMax.max.y > maxPoint.y) { maxPoint.y = shitaeLayerMinMax.max.y; }
        // }
      };
      // 全ての階を非表示にする
      // MINとMAXを調べる
      if (floor) {
        calculateBoud(floor);
      } else {
        for (let i: number = 1; i <= 3; i += 1) {
          calculateBoud(i);
        }
      }
      const retObject: THREE.Box2 = new THREE.Box2();
      if (minPoint != null && maxPoint != null) {
        minPoint.x -= marietta.webcad.WebCADGlobal.OUTERFRAME_LEFT_FRAME_WIDTH;
        minPoint.y -= marietta.webcad.WebCADGlobal.OUTERFRAME_HEADER_HEIGHT;
        maxPoint.x -= marietta.webcad.WebCADGlobal.OUTERFRAME_LEFT_FRAME_WIDTH;
        maxPoint.y -= marietta.webcad.WebCADGlobal.OUTERFRAME_HEADER_HEIGHT;
        retObject.setFromPoints([new THREE.Vector2(minPoint.x, minPoint.y), new THREE.Vector2(maxPoint.x, maxPoint.y)]);
      }
      return retObject;
    }

    /**
     * 印刷用
     * 指定した位置をオブジェクトの中心点とし、移動する
     * @param x 移動先のx座標 (オブジェクトの中心座標)
     * @param y 移動先のy座標 (オブジェクトの中心座標)
     */
    convertAllToSpecification(centerPoint:{x: number, y: number}, floor: number = null): void {
      const moveX: number = centerPoint.x;
      const moveY: number = centerPoint.y;
      let tarLayer: FloorLayer;
      // let tarLayerShitae: FloorShitaeLayer;
      if (floor) {
        tarLayer = this.getFloorLayer(floor);
        tarLayer.moveAllItems(moveX, moveY);
        tarLayer.layer_upstair.moveAll(moveX, moveY);
        // tarLayerShitae = this.getFloorLayer(floor, true) as FloorShitaeLayer;
        // tarLayerShitae.moveAllItems(moveX, moveY);
      } else {
        for (let i: number = 1; i <= 3; i += 1) {
          tarLayer = this.getFloorLayer(i);
          tarLayer.moveAllItems(moveX, moveY);
          tarLayer.layer_upstair.moveAll(moveX, moveY);
          // tarLayerShitae = this.getFloorLayer(i, true) as FloorShitaeLayer;
          // tarLayerShitae.moveAllItems(moveX, moveY);
        }
      }
      // 全体の移動距離を保持しておき、後生成アイテムのために保持しておく
      this.allPositionConversion.x += moveX;
      this.allPositionConversion.y += moveY;
    }
}
